import { render, staticRenderFns } from "./ImageFileInput.vue?vue&type=template&id=710d360d&scoped=true&"
import script from "./ImageFileInput.vue?vue&type=script&lang=ts&"
export * from "./ImageFileInput.vue?vue&type=script&lang=ts&"
import style0 from "./ImageFileInput.vue?vue&type=style&index=0&id=710d360d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "710d360d",
  null
  
)

export default component.exports